const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnGas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.26 56.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.37 27.51-.1 2.69a16 16 0 0 1-1.65 6.93 10.41 10.41 0 0 1-2.77 3.38.55.55 0 0 1-.29.09.47.47 0 0 1-.17 0 2 2 0 0 1-.34-.14 8.86 8.86 0 0 1-.94-.56c-.34-.21-2.51-1.88-3.43-2.6a.43.43 0 0 0-.65.16c-.58 1.27-2.06 4.68-2.11 6.38-.11 3.28 1.44 6.73 4.9 10.87a.56.56 0 0 1 0 .67.54.54 0 0 1-.45.24h0a.47.47 0 0 1-.17 0 27.36 27.36 0 0 1-10.58-6.25A15.08 15.08 0 0 1 .85 38.64c0-8.93 3.77-12.88 7.76-17.06C12.75 17.24 17 12.75 19 1.3a.55.55 0 0 1 .5-.45h0a.56.56 0 0 1 .4.14l1.28 1.14c7.72 7 12.78 12.92 15.87 18.52a35.21 35.21 0 0 1 4.36 17.85c0 9.33-7.86 16-15.46 17.07h0a.55.55 0 0 1-.43-1c2.24-2.06 6-6.39 6.12-12.21.06-4-1.81-8.32-5.54-12.83l-1.72-2.07",
    style: {
      fill: "none",
      stroke: "#4b4a4a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.7px"
    },
    "data-name": "Ebene 1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnGas);
export default __webpack_public_path__ + "static/media/icn-gas.233e91ab9002d2718f7f7eba0e46da1d.svg";
export { ForwardRef as ReactComponent };